// import axios from './axios'

import gun from './gun'
let contractJSON = require('../contracts/PatientRegistry.json')
let abi = contractJSON.abi;

require('web3-eth-personal');
let bytecode = '0x' + contractJSON.bytecode.object;

// import AuthenticationManager from './authenticationManager'
class PatientsManager {
    static GetPatients() {
        return new Promise((resolve) => {
            resolve(gun.get('patients').map())
        
    
        }).catch((e) => console.log(e))

    }

    static GetPatient(id) {
        return new Promise((resolve) => {
            resolve(gun.get('patients').get(id))
        })
    }
    static GetContract(address) {
        var web3 = window.web3
        let MedicalHistoryContract = new web3.eth.Contract(abi, address);
        return MedicalHistoryContract
    }

    static CreatePatient(patient) {
        // return new Promise((resolve) => {
        //     axios.post('/api/patients', patient).then(() => {
        //         resolve()
        //     })
        // })
        return new Promise((resolve) => {
            var web3 = window.web3

            // Create Contract proxy class
            let PatientContract = new web3.eth.Contract(abi, null, { data: bytecode, arguments: [patient.wallet, patient.name, patient.homeAddress, patient.date] });
            web3.eth.getGasPrice().then(price => {
                web3.eth.getAccounts().then(accounts => {
                    PatientContract.deploy({ arguments: [patient.wallet, patient.name, patient.homeAddress, patient.date] }).estimateGas().
                        then((estimatedGas) => {
                            let contractBlock = PatientContract.deploy({ arguments: [patient.wallet, patient.name, patient.homeAddress, patient.date] }).send({ from: accounts[0], gasPrice: price, gas: estimatedGas })
                            contractBlock.then((e) => {
                                var data = {
                                    name: patient.name,
                                    registerAddress: e._address,
                                    wallet: patient.wallet
                                }
                                gun.get('patients').get(patient.wallet).put(data)
                                resolve(true)
                                // axios.post('/api/patients', data).then(() => {
                                //     console.log("done")
                                //     resolve(true)
                                // })
                            })
                        }).
                        catch(console.error);
                }
                )
            })


        })
    }
}

export default PatientsManager